import { env } from "@/config/env";
import { initializeAmazonConnect } from "./";

const COLOR_PRIMARY_50 = "#ecf9ff";
const COLOR_PRIMARY_900 = "#0a469e";

export const AMAZON_BUTTON_ID = "launch-widget-btn";

export const toggleAmazonChatVisibility = (show: boolean) => {
  const styleId = "amazon-connect-visibility";
  let styleElement = document.getElementById(styleId);

  if (!styleElement) {
    styleElement = document.createElement("style");
    styleElement.id = styleId;
    document.head.appendChild(styleElement);
  }

  styleElement.textContent = `
    #amazon-connect-widget-frame {
      display: ${show ? "flex" : "none"} !important;
    }
  `;
};

interface ConnectAmazonChatParams {
  name: string;
  phoneNumber: string;
  email: string;
}

export const connectAmazonChat = ({
  name,
  phoneNumber,
  email,
}: ConnectAmazonChatParams) => {
  const amazon = initializeAmazonConnect(
    window,
    document,
    env.VITE_AMAZON_CONNECT_CHAT_SESSION_ID,
  );

  amazon("styles", {
    iconType: "CHAT",
    openChat: { color: COLOR_PRIMARY_50, backgroundColor: COLOR_PRIMARY_900 },
    closeChat: { color: COLOR_PRIMARY_50, backgroundColor: COLOR_PRIMARY_900 },
  });

  amazon("snippetId", env.VITE_AMAZON_CONNECT_CHAT_SNIPPET_ID);

  amazon("supportedMessagingContentTypes", [
    "text/plain",
    "text/markdown",
    "application/vnd.amazonaws.connect.message.interactive",
    "application/vnd.amazonaws.connect.message.interactive.response",
  ]);

  amazon("customizationObject", {
    header: {
      dropdown: false,
      dynamicHeader: false,
    },
    footer: {
      disabled: true,
      skipCloseChatButton: true,
    },
  });

  amazon("customLaunchBehavior", {
    skipIconButtonAndAutoLaunch: true,
    programmaticLaunch: function (launchCallback) {
      const launchWidgetBtn = document.getElementById(AMAZON_BUTTON_ID);
      if (launchWidgetBtn) {
        launchWidgetBtn.addEventListener("click", launchCallback);
        window.onunload = function () {
          launchWidgetBtn.removeEventListener("click", launchCallback);
          return;
        };
      }
    },
  });

  amazon("contactAttributes", {
    PlatformName: "LevelsRx",
    Name: name,
    Phone: phoneNumber,
    Email: email,
  });

  amazon("customerDisplayName", function (callback) {
    callback(name);
  });
};
